import React from "react";
import { Box, Heading, Stack, Text } from "@origin-digital/ods-core";
import { TileButton, TileButtonGroup } from "@origin-digital/ods-tile-button";
import { IconBoxedReward, IconPromoTag } from "@origin-digital/ods-icons";
import { ILPGOffer } from "../../model/ILPGOffer";
import content from "./content.json";

interface IOfferSelectorProps {
  offers: ILPGOffer[];
  selectedOffer: string | null;
  onSelectOffer: (salesforceId: string) => void;
}

export const OfferSelector = ({
  offers,
  selectedOffer,
  onSelectOffer,
}: IOfferSelectorProps) => {
  if (!offers.length) return null;

  const heading = offers.length === 1 ? "Your Offer" : content.heading;

  return (
    <Stack space="medium" data-id="offer-selector-section">
      <Box paddingX={{ xs: "medium", sm: "xxlarge", lg: "none" }}>
        <Heading variant="h3" data-id="offer-selector-heading">
          {heading}
        </Heading>
      </Box>
      {offers.length > 1 && (
        <Box
          width="full"
          paddingY="xxxsmall"
          style={{ overflow: "scroll", scrollbarWidth: "none" }}
        >
          <Box
            paddingX={{ xs: "medium", sm: "xxlarge", lg: "xxxsmall" }}
            style={{ minWidth: "628px" }}
          >
            <TileButtonGroup
              id="offer-selector"
              data-id="offer-selector"
              value={selectedOffer ?? ""}
              cols={3}
              togglePosition="right"
              noChildPadding
              hideHelperTextSpace
              onChange={(_event, val) => {
                if (val) onSelectOffer(val as string);
              }}
            >
              {offers.map((offer) => (
                <TileButton
                  key={offer.salesforceId}
                  aria-label={offer.offerName}
                  data-id={`offer-selector-button-${offer.salesforceId}`}
                  id={`offer-tile-${offer.salesforceId}`}
                  value={offer.salesforceId}
                  selected={selectedOffer === offer.salesforceId}
                  muiProps={{ style: { alignItems: "flex-start" } }}
                  responsiveLayout
                  multiLineDesc={true}
                  backgroundColor={
                    selectedOffer === offer.salesforceId
                      ? "secondary"
                      : undefined
                  }
                  label={
                    <Stack space="xsmall">
                      {offer.rewardOffer ? (
                        <IconBoxedReward
                          color="neutralDark"
                          aria-label="Everyday Rewards offer"
                          data-id="offer-edr-icon"
                        />
                      ) : (
                        <IconPromoTag color="neutralDark" />
                      )}
                    </Stack>
                  }
                >
                  {offer.offerAdditionalInformation[0] && (
                    <Text tone="neutralDark">
                      {offer.offerAdditionalInformation[0]}
                    </Text>
                  )}
                </TileButton>
              ))}
            </TileButtonGroup>
          </Box>
        </Box>
      )}
    </Stack>
  );
};
